import {
  UserActivityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';
import type { AgentWrapupStartedEvent } from '@servicetitan/telecom-rtcs-client';

/** Derived from AgentWrapupStartedEvent.stats - not directly exported from package */
type AgentStats = NonNullable<AgentWrapupStartedEvent['stats']>;

export type ServiceUserStats = {
  avgCallTime: number;
  lastActionAt: string;
  lastHandledAt: string;
  lastIdleAt: string;
  loginAt: string;
  missedSessions: number;
  offeredSessions: number;
  totalSessions: number;
};

export function userStatsFromAgentStats(stats: AgentStats): ServiceUserStats {
  return {
    lastActionAt: stats.lastActionTime,
    lastHandledAt: stats.lastHandledTime,
    lastIdleAt: stats.lastIdleTime,
    loginAt: stats.loginTime,
    totalSessions: stats.acceptedSessions,
    offeredSessions: stats.offeredSessions,
    missedSessions: stats.missedSessions,
    avgCallTime: stats.averageSessionMs,
  };
}

type ServiceUser = {
  id: string;
  contactCenterUserId?: string | null;
  email: string;
  name: string;
  username?: string | null;
  stats?: ServiceUserStats | null;
  recoveryTime?: number;
  personalLine?: {
    phoneNumber?: string | null;
  } | null;

  activityStatus: UserActivityStatus;
  availabilityStatus: UserSetAvailabilityStatus;
};

export default ServiceUser;
